/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AvailableNotificationsResponse } from './availableNotificationsResponse';

export type GenericApiResponseAvailableNotificationsResponseData = AvailableNotificationsResponse | null;
